export const REQUEST_DEALER = 'page/dealer/REQUEST_DEALER';
export const HANDLE_RESPONSE_DEALER = 'page/dealer/HANDLE_RESPONSE_DEALER';
export const REQUEST_MORE_LISTINGS = 'page/dealer/REQUEST_MORE_LISTINGS';
export const HANDLE_RESPONSE_MORE_LISTINGS =
  'page/dealer/HANDLE_RESPONSE_MORE_LISTINGS';
export const HANDLE_RESPONSE_ERROR_MORE_SEARCH_RESULTS =
  'page/dealer/HANDLE_RESPONSE_ERROR_MORE_SEARCH_RESULTS';
